import { property as c } from "../beacon-property.d/index.js";
import { e as p, a as u, B as h } from "./abstract-base-DlmRC3qm.js";
import { m } from "./lifecycle-decorators-CUsT9aHq.js";
import { B } from "./beacon-primitive-ChVMWFlW.js";
import { a as l } from "./query-assigned-DZ4JAxBy.js";
import { i as f } from "./utils-BSj5iT7c.js";
var v = Object.defineProperty, y = Object.getOwnPropertyDescriptor, a = (s, e, o, n) => {
  for (var t = n > 1 ? void 0 : n ? y(e, o) : e, r = s.length - 1, i; r >= 0; r--)
    (i = s[r]) && (t = (n ? i(e, o, t) : i(t)) || t);
  return n && t && v(e, o, t), t;
};
const F = () => function(e) {
  let o = class extends e {
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-input - emits when a standard input event would be fired
     */
    emitInput(n, t) {
      p(this, u.INPUT, !!this.onBeaconInput && this.onBeaconInput(n, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-change - emits when a standard change event would be fired
     */
    emitChange(n, t) {
      p(this, u.CHANGE, !!this.onBeaconChange && this.onBeaconChange(n, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-focus - emits when a beacon form component receives focus
     */
    emitFocus(n, t) {
      p(this, u.FOCUS, !!this.onBeaconFocus && this.onBeaconFocus(n, t));
    }
    /**
     * @param event
     * @event {BeaconEvents} beacon-event-blur - emits when a beacon form component loses focus
     */
    emitBlur(n, t) {
      p(this, u.BLUR, !!this.onBeaconBlur && this.onBeaconBlur(n, t));
    }
    /**
     * TODO: No need
     * @param event
     * @event {BeaconEvents} beacon-event-mousedown - emits when a mousedown event would be fired
     */
    emitMousedown(n) {
      p(this, u.MOUSEDOWN, !!this.onBeaconMousedown && this.onBeaconMousedown());
    }
  };
  return a([
    c({ type: Function })
  ], o.prototype, "onBeaconChange", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconBlur", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconInput", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconFocus", 2), a([
    c({ type: Function })
  ], o.prototype, "onBeaconMousedown", 2), o = a([
    m("FormEvents")
  ], o), o;
};
var d = Object.defineProperty, _ = (s, e, o, n) => {
  for (var t = void 0, r = s.length - 1, i; r >= 0; r--)
    (i = s[r]) && (t = i(e, o, t) || t);
  return t && d(e, o, t), t;
};
class C extends B(h, F()) {
  static get formAssociated() {
    return !0;
  }
  constructor() {
    super(), f ? this.internals = null : this.internals = this.attachInternals ? this.attachInternals() : null;
  }
  /**
   * Implement `ElementInternals.setValidity()` with default values.
   * @param flags Custom validation flags.
   * @param message Error message used in validation.
   * @param anchor Validation target to receive focus, typically the form control element used in the shadow DOM.
   */
  setValidity(e, o, n = this.formAnchor) {
    this.internals && this.internals.setValidity(e, o, n);
  }
}
_([
  l(".form-anchor")
], C.prototype, "formAnchor");
export {
  C as B
};
